import {
  Activity,
  ActivitySquare,
  Apple,
  BedDouble,
  Bike,
  Book,
  Box,
  Building,
  Bus,
  BusFront,
  CakeSlice,
  Calculator,
  Camera,
  Car,
  CarFront,
  CarTaxiFront,
  Castle,
  Church,
  CircleDollarSign,
  Clapperboard,
  Coffee,
  Cross,
  Dice6,
  Dumbbell,
  FerrisWheel,
  Flower,
  Flower2,
  Footprints,
  Fuel,
  GraduationCap,
  Heart,
  HeartPulse,
  Home,
  Lamp,
  Landmark,
  MapPin,
  Martini,
  Mountain,
  ParkingCircle,
  PartyPopper,
  PawPrint,
  Pill,
  Plane,
  PlugZap,
  Scale,
  Scissors,
  Shirt,
  ShoppingBag,
  ShoppingBasket,
  ShoppingCart,
  Siren,
  Sofa,
  Squirrel,
  Star,
  Store,
  TrafficCone,
  TreePine,
  Trees,
  Trophy,
  Truck,
  Umbrella,
  User,
  Utensils,
  Wine,
  Wrench,
  Zap,
  Plug,
} from "lucide-react";
import React from "react";

const typeMapping = {
  lodging: { icon: <BedDouble size={40} />, translation: "hospedagem" },
  car_dealer: { icon: <Car size={40} />, translation: "revendedor de carros" },
  parking: { icon: <ParkingCircle size={40} />, translation: "estacionamento" },
  park: { icon: <TreePine size={40} />, translation: "parque" },
  point_of_interest: {
    icon: <Star size={40} />,
    translation: "ponto de interesse",
  },
  route: { icon: <MapPin size={40} />, translation: "rota" },
  gas_station: { icon: <Fuel size={40} />, translation: "posto de gasolina" },
  cafe: { icon: <Coffee size={40} />, translation: "café" },
  restaurant: { icon: <Utensils size={40} />, translation: "restaurante" },
  moving_company: {
    icon: <Truck size={40} />,
    translation: "empresa de mudanças",
  },
  food: { icon: <Apple size={40} />, translation: "mercado" },
  store: { icon: <ShoppingCart size={40} />, translation: "loja" },
  laundry: { icon: <Shirt size={40} />, translation: "lavanderia" },
  school: { icon: <GraduationCap size={40} />, translation: "escola" },
  bar: { icon: <Martini size={40} />, translation: "bar" },
  university: {
    icon: <GraduationCap size={40} />,
    translation: "universidade",
  },
  shopping_mall: {
    icon: <ShoppingBag size={40} />,
    translation: "shopping center",
  },
  grocery_or_supermarket: {
    icon: <ShoppingBasket size={40} />,
    translation: "supermercado",
  },
  accounting: { icon: <Calculator size={40} />, translation: "contabilidade" },
  electrician: { icon: <Zap size={40} />, translation: "eletricista" },
  meal_takeaway: {
    icon: <Utensils size={40} />,
    translation: "entrega de refeição",
  },
  car_rental: {
    icon: <CarFront size={40} />,
    translation: "locadora de carros",
  },
  spa: { icon: <Flower size={40} />, translation: "spa" },
  health: { icon: <Heart size={40} />, translation: "clínica" },
  convenience_store: {
    icon: <Store size={40} />,
    translation: "loja de conveniência",
  },
  general_contractor: {
    icon: <Wrench size={40} />,
    translation: "construtora",
  },
  electronics_store: {
    icon: <PlugZap size={40} />,
    translation: "loja de eletrônicos",
  },
  lawyer: { icon: <Scale size={40} />, translation: "advogado" },
  gym: { icon: <Dumbbell size={40} />, translation: "academia" },
  real_estate_agency: { icon: <Home size={40} />, translation: "imobiliária" },
  supermarket: {
    icon: <ShoppingBasket size={40} />,
    translation: "supermercado",
  },
  premise: { icon: <Home size={40} />, translation: "construção" },
  car_repair: { icon: <Wrench size={40} />, translation: "oficina mecânica" },
  hospital: { icon: <Activity size={40} />, translation: "hospital" },
  travel_agency: {
    icon: <Plane size={40} />,
    translation: "agência de viagens",
  },
  furniture_store: { icon: <Sofa size={40} />, translation: "loja de móveis" },
  movie_theater: { icon: <Clapperboard size={40} />, translation: "cinema" },
  transit_station: {
    icon: <BusFront size={40} />,
    translation: "estação de transporte",
  },
  airport: { icon: <Plane size={40} />, translation: "aeroporto" },
  hair_care: { icon: <Scissors size={40} />, translation: "salão de beleza" },
  pharmacy: { icon: <Pill size={40} />, translation: "farmácia" },
  tourist_attraction: {
    icon: <Camera size={40} />,
    translation: "atração turística",
  },
  stadium: { icon: <Trophy size={40} />, translation: "estádio" },
  car_wash: { icon: <CarTaxiFront size={40} />, translation: "lava-rápido" },
  home_goods_store: {
    icon: <Lamp size={40} />,
    translation: "loja de artigos para casa",
  },
  shoe_store: {
    icon: <Footprints size={40} />,
    translation: "loja de calçados",
  },
  clothing_store: { icon: <Shirt size={40} />, translation: "loja de roupas" },
  beauty_salon: { icon: <User size={40} />, translation: "salão de beleza" },
  doctor: { icon: <HeartPulse size={40} />, translation: "médico" },
  finance: { icon: <CircleDollarSign size={40} />, translation: "banco" },
  florist: { icon: <Flower2 size={40} />, translation: "floricultura" },
  sublocality_level_1: {
    icon: <MapPin size={40} />,
    translation: "sublocalidade nível 1",
  },
  natural_feature: { icon: <Mountain size={40} />, translation: "parada" },
  storage: { icon: <Box size={40} />, translation: "armazém" },
  local_government_office: {
    icon: <Building size={40} />,
    translation: "prédio público",
  },
  administrative_area_level_2: {
    icon: <MapPin size={40} />,
    translation: "prédio público",
  },
  hardware_store: {
    icon: <Wrench size={40} />,
    translation: "loja de ferragens",
  },
  city_hall: { icon: <Building size={40} />, translation: "prédio público" },
  bakery: { icon: <CakeSlice size={40} />, translation: "padaria" },
  drugstore: { icon: <Pill size={40} />, translation: "farmácia" },
  veterinary_care: {
    icon: <PawPrint size={40} />,
    translation: "cuidados veterinários",
  },
  campground: { icon: <Trees size={40} />, translation: "camping" },
  locality: { icon: <MapPin size={40} />, translation: "localidade" },
  amusement_park: {
    icon: <FerrisWheel size={40} />,
    translation: "parque de diversões",
  },
  museum: { icon: <Castle size={40} />, translation: "museu" },
  library: { icon: <Book size={40} />, translation: "biblioteca" },
  primary_school: {
    icon: <Building size={40} />,
    translation: "escola primária",
  },
  church: { icon: <Church size={40} />, translation: "igreja" },
  cemetery: { icon: <Cross size={40} />, translation: "cemitério" },
  department_store: {
    icon: <ShoppingBag size={40} />,
    translation: "loja de departamentos",
  },
  bank: { icon: <Landmark size={40} />, translation: "banco" },
  bicycle_store: {
    icon: <Bike size={40} />,
    translation: "loja de bicicletas",
  },
  meal_delivery: { icon: <Utensils size={40} />, translation: "restaurante" },
  street_address: { icon: <MapPin size={40} />, translation: "endereço" },
  insurance_agency: {
    icon: <Umbrella size={40} />,
    translation: "agência de seguros",
  },
  taxi_stand: {
    icon: <CarTaxiFront size={40} />,
    translation: "ponto de táxi",
  },
  atm: { icon: <Landmark size={40} />, translation: "caixa eletrônico" },
  pet_store: { icon: <PawPrint size={40} />, translation: "pet shop" },
  liquor_store: { icon: <Wine size={40} />, translation: "loja de bebidas" },
  dentist: { icon: <ActivitySquare size={40} />, translation: "dentista" },
  secondary_school: {
    icon: <Landmark size={40} />,
    translation: "escola secundária",
  },
  physiotherapist: {
    icon: <HeartPulse size={40} />,
    translation: "fisioterapeuta",
  },
  police: { icon: <Siren size={40} />, translation: "polícia" },
  town_square: { icon: <Trees size={40} />, translation: "praça da cidade" },
  bus_station: { icon: <Bus size={40} />, translation: "estação de ônibus" },
  place_of_worship: {
    icon: <Church size={40} />,
    translation: "local de culto",
  },
  casino: { icon: <Dice6 size={40} />, translation: "cassino" },
  courthouse: { icon: <Landmark size={40} />, translation: "tribunal" },
  intersection: { icon: <TrafficCone size={40} />, translation: "interseção" },
  country: { icon: <MapPin size={40} />, translation: "ponto" },
  zoo: { icon: <Squirrel size={40} />, translation: "zoológico" },
  sublocality_level_3: {
    icon: <MapPin size={40} />,
    translation: "sublocalidade nível 3",
  },
  night_club: { icon: <PartyPopper size={40} />, translation: "clube noturno" },
  funeral_home: { icon: <Cross size={40} />, translation: "casa funerária" },
};

export function LocationType({ type }: any) {
  const { icon, translation } = (
    typeMapping as Record<
      string,
      { icon: JSX.Element; translation: string } | undefined
    >
  )[type] || {
    icon: <PlugZap size={40} />,
    translation: type || "Unknown",
  };
  return (
    <div className="bg-primary/ flex aspect-square w-28 flex-col items-center justify-center space-y-2">
      <span>{icon}</span>
      <p className="text-center text-sm capitalize">{translation}</p>
    </div>
  );
}

export function LocationName({ type }: any) {
  const { translation } = (
    typeMapping as Record<
      string,
      { icon: JSX.Element; translation: string } | undefined
    >
  )[type] || {
    icon: <PlugZap size={40} />,
    translation: type || "Unknown",
  };
  return (
    <p className="flex text-sm font-bold capitalize md:hidden">{translation}</p>
  );
}
